import { createStyles } from 'antd-style';

export const useSlidingContentStyles = createStyles(({ token }) => ({
  slidingContent: {
    width: '100%',

    '&.vertical': {
      display: 'flex',
      flexDirection: 'column',

      '.SlidingContent-ContentAnimationContainer': {
        flex: 1,
      },
    },

    '.SlidingContent-Content': {
      // This is a reserve for shadows and other graphical content on the edge
      margin: '0 -20px',
      overflow: 'hidden',
      position: 'relative',
    },

    '&.anim-md, &': {
      '.SlidingContent-ContentAnimationContainer': {
        transition: `transform ${token.motionDurationMid}`,
      },
    },
    '&.anim-lg': {
      '.SlidingContent-ContentAnimationContainer': {
        transition: `transform ${token.motionDurationSlow}`,
      },
    },

    '.SlidingContent-ContentAnimationContainer': {
      width: '100%',
      height: '100%',
      whiteSpace: 'nowrap',

      '&.vertical': {
        whiteSpace: 'normal',
      },
    },

    '.SlidingContent-ContentTab': {
      width: '100%',
      minHeight: '100%',
      display: 'inline-block',
      whiteSpace: 'initial',
      verticalAlign: 'top',
      padding: '0 20px',
      overflow: 'hidden',

      '.SlidingContent-Content-AutoHeight &': {
        minHeight: 0,
      },
    },
  },
  buttons: {
    width: '100%',
    display: 'flex',
    marginBottom: 10,
  },
  contentOverlay: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    right: 0,
    pointerEvents: 'none',

    '> *': {
      pointerEvents: 'initial',
    },
  },
}));
